import { render, staticRenderFns } from "./SingleCategorySelector.vue?vue&type=template&id=6350aa7a&"
import script from "./SingleCategorySelector.vue?vue&type=script&lang=js&"
export * from "./SingleCategorySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports